import Link from "next/link"
import React, {useEffect, useRef, useState} from "react"
import {CaretRightFill} from "react-bootstrap-icons"
import Typography from "../reusable/Typography/Typography"
import parse from "html-react-parser"
import DesktopSocialShare from "../bikeDetails/DesktopSocialShare"
import MobileShare from "../reusable/components/MobileShare"
import {useTranslation} from "next-i18next"
import styles from "./BlogPost.module.scss"
import BlogPostBookConsultation from "./BlogPostBookConsultation"
import BookConsultationFixedBtn from "./BookConsultationFixedBtn"
import useOnScreen from "../../hooks/OnScreen"

type Props = {
	title: string
	content: string
}

const BlogPostContent = ({title, content}:Props) : React.ReactElement => {
	const {t} = useTranslation()
	const [isFixedBtnVisible, setIsFixedBtnVisible] = useState<boolean>(true)
	const ref = useRef()
	const onScreen = useOnScreen(ref)

	useEffect(() => {
		setIsFixedBtnVisible(onScreen)
	}, [onScreen])
	return (
		<main className="bg-white">
			<div className="d-md-none">
				<BookConsultationFixedBtn visible={!isFixedBtnVisible}/>
			</div>
			<div className="container pt-4 pt-md-5 pb-5">
				<div className={"row"}>
					<div className={"mt-2 mb-2 text-dark"}>
						<Link href={t("/blog")}>
							<small className={"pointer"}>{t("Blog")}</small>
						</Link>
						<CaretRightFill className={"ms-2 me-2"}
							size={10}/>
						<small className={"text-bold"}>{parse(title)}</small>
					</div>
				</div>
				<div className="wp-post row justify-content-center">
					<div className="d-none d-md-block col-12 col-md-5 col-lg-3 mb-4 mt-2">
						<BlogPostBookConsultation isAskUsDesign/>
					</div>
					<div className={"col-12 col-md-7 col-lg-9"}>
						<div className={"row justify-content-center"}>
							<div className={"col-12 col-md-10 col-lg-10 mt-3 mt-xl-5"}
								style={{maxWidth: 800}}>
								<div ref={ref}
									className="d-flex d-md-block mb-4 mb-xl-5">
									<Typography variant="heading1"
										semanticTag={"h1"}
										className={"text-start"}>
										{parse(title)}
									</Typography>
									<div className="mt-3 ms-1 d-md-none"><MobileShare /></div>
									<div className="d-none d-md-flex">
										<DesktopSocialShare t={t} />
									</div>
								</div>
								<div className={`text-start ${styles.content}`}>
									{parse(content)}
								</div>
								<div className="mt-5 rounded-circle d-md-none mx-auto"
									style={{width: 35, height: 35, backgroundColor: "#ccc"}}><MobileShare /></div>
								<div className="d-none d-md-block">
									<DesktopSocialShare t={t} />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</main>
	)
}

export default BlogPostContent
